import React from "react"
import { Loading } from "letalkui"

import UpsellAgentPage from "@/pages/Admin/Agent/UpsellAgentPage"

import AgentList from "@/pages/Admin/Agent/AgentList"

import { useGlobalStateStore } from "@/store/GlobalState"

const Agents = () => {
	const globalStateStore = useGlobalStateStore()

	const canViewAgentList = globalStateStore.instance.subscriptionData?.limits?.permission?.agent

	return <Loading.FallbackSpinner isLoading={false}>
		{!canViewAgentList ? <UpsellAgentPage /> : <AgentList />}
	</Loading.FallbackSpinner>
}

export default Agents
